import styled from 'styled-components';
import { Flex } from 'dash-ui';

export const FlexWraper = styled(Flex)`
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;
